import React from 'react';
import './InfoPage.css';

function HostCommunity() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Fórum da Comunidade</h1>

        <section className="info-section">
          <h2>Conecte-se com anfitriões ao redor do mundo</h2>
          <p>Junte-se a milhares de anfitriões compartilhando experiências, dicas e suporte no Fórum da Comunidade Nukki. Aprenda com outros, compartilhe sua experiência e construa conexões com anfitriões companheiros.</p>
        </section>

        <section className="info-section">
          <h3>Categorias Populares do Fórum</h3>

          <div className="feature-grid">
            <div className="feature-box">
              <h4>Cantinho do Novo Anfitrião</h4>
              <p>Está começando? Faça perguntas, compartilhe preocupações e obtenha conselhos de anfitriões experientes que estiveram no seu lugar.</p>
            </div>
            <div className="feature-box">
              <h4>Dicas e Melhores Práticas</h4>
              <p>Compartilhe e descubra ideias criativas para melhorar seu anúncio, experiência do hóspede e negócio de hospedagem.</p>
            </div>
            <div className="feature-box">
              <h4>Grupos de Anfitriões Locais</h4>
              <p>Conecte-se com anfitriões da sua área para discutir regulamentações locais, tendências de mercado e estratégias regionais de hospedagem.</p>
            </div>
            <div className="feature-box">
              <h4>Histórias de Sucesso</h4>
              <p>Celebre vitórias, compartilhe conquistas marcantes e inspire outros com sua jornada de hospedagem.</p>
            </div>
            <div className="feature-box">
              <h4>Resolução de Problemas</h4>
              <p>Obtenha ajuda com desafios, problemas técnicos ou situações difíceis com hóspedes da comunidade.</p>
            </div>
            <div className="feature-box">
              <h4>Manutenção de Propriedades</h4>
              <p>Discuta limpeza, reparos, reformas e como manter sua propriedade em ótimas condições.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Eventos da Comunidade</h3>

          <div className="help-topic">
            <h4>Encontros Virtuais</h4>
            <p>Participe de encontros mensais virtuais de anfitriões para fazer networking, aprender com palestrantes especializados e participar de sessões de perguntas e respostas.</p>
            <ul>
              <li>Orientação Mensal para Novos Anfitriões</li>
              <li>Webinars de Estratégias Avançadas de Hospedagem</li>
              <li>Atualizações de Mercado Regional</li>
              <li>Série de Palestrantes Convidados Especialistas</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Encontros Locais</h4>
            <p>Conecte-se pessoalmente com anfitriões da sua cidade em encontros e eventos locais organizados.</p>
            <ul>
              <li>Encontros de Café para Anfitriões Locais</li>
              <li>Conferências Regionais Trimestrais</li>
              <li>Tours de Propriedades e Casas Abertas</li>
              <li>Eventos de Networking</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Encontro Anual de Anfitriões</h4>
            <p>Junte-se a nós para nosso encontro anual de anfitriões com palestrantes principais, workshops, oportunidades de networking e as últimas atualizações da plataforma.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Programas da Comunidade</h3>

          <div className="feature-box">
            <h4>Mentoria de Anfitriões</h4>
            <p>Novos anfitriões podem ser emparelhados com mentores experientes que fornecem orientação e suporte durante seus primeiros meses de hospedagem.</p>
          </div>

          <div className="feature-box">
            <h4>Reconhecimento de Superanfitrião</h4>
            <p>Celebre anfitriões que consistentemente proporcionam experiências excepcionais. Superanfitriões recebem um selo especial, maior visibilidade e benefícios exclusivos.</p>
          </div>

          <div className="feature-box">
            <h4>Programa de Embaixadores Anfitriões</h4>
            <p>Anfitriões experientes que desejam retribuir podem se tornar embaixadores, liderando comunidades locais e representando interesses dos anfitriões.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Diretrizes da Comunidade</h3>
          <p>Nossa comunidade prospera com respeito, apoio e diálogo construtivo. Por favor, siga estas diretrizes:</p>
          <ul>
            <li>Seja respeitoso e cortês com todos os membros da comunidade</li>
            <li>Compartilhe informações precisas e cite fontes quando possível</li>
            <li>Proteja a privacidade dos hóspedes - nunca compartilhe informações pessoais</li>
            <li>Mantenha discussões construtivas e focadas em soluções</li>
            <li>Relate conteúdo ou comportamento inadequado</li>
            <li>Evite spam promocional ou publicidade fora do tópico</li>
            <li>Respeite propriedade intelectual e direitos autorais</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Discussões em Destaque</h3>

          <div className="help-topic">
            <h4>Tópicos em Alta Esta Semana</h4>
            <ul>
              <li>Como otimizar seu anúncio para reservas de verão</li>
              <li>Práticas de hospedagem ecológicas que os hóspedes adoram</li>
              <li>Lidando com cancelamentos de última hora</li>
              <li>Dispositivos domésticos inteligentes que melhoram a experiência do hóspede</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Tópicos de Leitura Obrigatória</h4>
            <ul>
              <li>O Guia Completo para Iniciantes em Hospedagem (mais de 2000 respostas)</li>
              <li>Dicas de Fotografia de Anfitriões Profissionais (mais de 850 respostas)</li>
              <li>Lidando com Hóspedes Difíceis: Histórias Reais e Soluções (mais de 1200 respostas)</li>
              <li>Dicas Fiscais para Anfitriões: Um Guia Completo (mais de 600 respostas)</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Participe</h3>
          <p>Pronto para entrar na conversa? Veja como começar:</p>
          <ol>
            <li>Crie seu perfil no fórum e se apresente</li>
            <li>Navegue pelas categorias e participe de discussões que lhe interessam</li>
            <li>Faça perguntas e compartilhe suas experiências</li>
            <li>Siga tópicos e anfitriões para se manter atualizado</li>
            <li>Ganhe selos da comunidade por participação</li>
          </ol>
        </section>

        <div className="cta-section">
          <h3>Junte-se à Comunidade Hoje</h3>
          <p>Conecte-se com milhares de anfitriões prontos para ajudá-lo a ter sucesso</p>
          <button className="btn-white">Visitar o Fórum</button>
        </div>
      </div>
    </div>
  );
}

export default HostCommunity;
